import { c as _c } from "react/compiler-runtime";
import { CardContentBadge, Tooltip } from "@opensea/ui-kit";
import { VisibilityOff } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
export function HiddenItemBadge() {
  const $ = _c(5);
  const t = useTranslations("HiddenItemBadge");
  let t0;
  if ($[0] !== t) {
    t0 = t("hiddenItemMessage");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VisibilityOff className="rounded-full bg-black/80 p-1.5" color="white" size={32} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <CardContentBadge active={true} className="absolute top-auto right-auto bottom-2 left-2"><Tooltip className="max-w-80 text-center" content={t0}>{t1}</Tooltip></CardContentBadge>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}